import { render, staticRenderFns } from "./MiddleUI.vue?vue&type=template&id=062a3fe4"
import script from "./MiddleUI.vue?vue&type=script&lang=js"
export * from "./MiddleUI.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports